const script = document.createElement('script');

script.type = "text/javascript";
script.async = true;
script.src = 'https://mylivechat.com/chatinline.aspx?hccid=17608854';

document.body.appendChild(script);